import { createSlice, PayloadAction } from "@reduxjs/toolkit"

interface ChatStateType {
    chatsList: any[];
    chatsMessages: any[];
    currentChatID: string;
    selectedMsg: any;
}

const initialState: ChatStateType = {
    chatsList: [],
    chatsMessages: [],
    currentChatID: "",
    selectedMsg: null
}

const ChatState = createSlice({
    name: "ChatState",
    initialState,
    reducers: {
        setChatsList: (state, action: PayloadAction<any[]>) => {
            state.chatsList = action.payload
        },
        setCurrentChatID: (state, action: PayloadAction<string>) => {
            state.currentChatID = action.payload
        },
        setAllMessages: (state, action: PayloadAction<any[]>) => {
            state.chatsMessages = action.payload
        },
        selectMsg: (state, action: PayloadAction<any>) => {
            const currentChat = state.chatsMessages.filter((list) => list.chatToken === state.currentChatID);
            const selectedMsg = currentChat[0]?.messages.filter((msg: any) => msg.id === action.payload);
            state.selectedMsg = selectedMsg;
        }
    }
})

export const { setChatsList, setCurrentChatID, setAllMessages, selectMsg } = ChatState.actions

export default ChatState.reducer
